import { render, staticRenderFns } from "./TapModal.vue?vue&type=template&id=38e0d530&"
import script from "./TapModal.vue?vue&type=script&lang=js&"
export * from "./TapModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports